import { LinkItem } from '@occc-app/design-system';

import { routeCreator } from '../utils';

export const breadcrumbLinks: LinkItem[] = [
  { to: routeCreator.list(), label: 'Locations' },
  { key: routeCreator.create(), label: 'Create Location' },
];
